import React from 'react';

interface HedgehogSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
}

export const HedgehogSpinner: React.FC<HedgehogSpinnerProps> = ({
  size = 'md',
  label = 'INGESTING...',
  className = '',
}) => {
  const pixelSize = size === 'sm' ? 32 : size === 'md' ? 56 : 80;

  return (
    <div className={`flex flex-col items-center justify-center gap-3 select-none ${className}`}>
      <div className="relative" style={{ width: pixelSize, height: pixelSize }}>
        {/* Orbital SVG Data Ring */}
        <svg
          className="absolute inset-0 animate-spin"
          style={{ animationDuration: '2.5s' }}
          viewBox="0 0 100 100"
        >
          <circle
            cx="50"
            cy="50"
            r="44"
            fill="none"
            className="stroke-cf-border"
            strokeWidth="2"
            strokeDasharray="8 8"
          />
          {/* Orbiting data nodes */}
          <circle cx="50" cy="6" r="3.5" className="fill-cf-textPrimary" />
          <circle cx="94" cy="50" r="3.5" className="fill-cf-textSecondary" />
          <circle cx="50" cy="94" r="3.5" className="fill-cf-textMuted" />
        </svg>

        {/* Center Mascot Silhouette with Pulsing Glow */}
        <div className="absolute inset-0 flex items-center justify-center">
          <svg
            width={pixelSize * 0.6}
            height={pixelSize * 0.6}
            viewBox="0 0 32 32"
            fill="none"
            className="animate-pulse"
          >
            <path
              d="M 6 22 L 4 14 L 10 17 L 9 8 L 16 14 L 17 4 L 22 13 L 26 8 L 25 18 Z"
              className="fill-cf-textPrimary"
            />
            <path
              d="M 6 22 C 6 26 12 28 19 28 C 26 28 29 25 30 22 C 30 20 28 18 25 18 L 10 18 C 8 18 6 20 6 22 Z"
              className="fill-cf-surfaceActive stroke-cf-border"
              strokeWidth="1"
            />
            <circle cx="26" cy="19.5" r="1.2" className="fill-cf-textPrimary" />
          </svg>
        </div>
      </div>

      {label && (
        <span className="text-xs tracking-widest text-cf-textSecondary uppercase">
          {label}
        </span>
      )}
    </div>
  );
};
